import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import type { EventDisplayMode } from '@/components';

interface ResultsSummaryProps {
    eventCount: number;
    sourceCount?: number;
    query: string | null;
    displayMode?: EventDisplayMode;
}

export function ResultsSummary({
    eventCount,
    sourceCount,
    query,
    displayMode = 'events',
}: ResultsSummaryProps) {
    const { t } = useTranslation(I18nNamespace.EVENTS);
    const showSourceCount = sourceCount !== undefined;
    const countKey =
        displayMode === 'alerts'
            ? 'summary.alertsCount'
            : 'summary.eventsCount';

    return (
        <div className="mb-6">
            <p className="text-md">
                <span className="text-white-100">
                    {t(countKey, { count: eventCount })}
                </span>
                <span className="text-grey-200"> {t('summary.found')}</span>
                {showSourceCount && (
                    <>
                        <span className="text-grey-200">
                            {t('summary.from')}
                        </span>
                        <span className="text-white-100">
                            {t('summary.sourcesCount', { count: sourceCount })}
                        </span>
                    </>
                )}
                {query && query.trim() && (
                    <>
                        <span className="text-grey-200">
                            {t('summary.for')}
                        </span>
                        <span className="text-white-100">"{query}"</span>
                    </>
                )}
            </p>
        </div>
    );
}
